import { useEffect, useState } from "react";

const navLinks = [
  { key: "trending", label: "下饭神番", icon: "ri-fire-line" },
  { key: "categories", label: "主题分类", icon: "ri-grid-line" },
  { key: "new-season", label: "新番速递", icon: "ri-flashlight-line" },
  { key: "reviews", label: "口碑评价", icon: "ri-chat-smile-line" },
  { key: "faq", label: "常见问题", icon: "ri-question-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-16 md:h-20">
        {/* logo */}
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-emotion-happy-fill text-xl"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-900">
            小狗看番
          </span>
        </a>

        {/* desktop links */}
        <ul className="hidden md:flex items-center gap-1 bg-background-50/80 border border-background-200 rounded-full px-1 py-1">
          {navLinks.map((link) => (
            <li key={link.key}>
              <a
                href={`#${link.key}`}
                className="flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 whitespace-nowrap transition-colors"
              >
                <i className={`${link.icon} text-base`}></i>
                <span>{link.label}</span>
              </a>
            </li>
          ))}
        </ul>

        {/* right actions */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#trending"
            className="whitespace-nowrap rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 text-sm font-bold transition-colors"
          >
            开始看番
          </a>
        </div>

        {/* mobile hamburger */}
        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 rounded-full flex items-center justify-center bg-background-50 border border-background-200 text-foreground-900"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {/* mobile panel */}
      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 pb-4">
          <ul className="flex flex-col gap-1 pt-3">
            {navLinks.map((link) => (
              <li key={link.key}>
                <a
                  href={`#${link.key}`}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center gap-2 px-3 py-3 rounded-lg text-sm text-foreground-800 hover:bg-primary-50 hover:text-primary-600"
                >
                  <i className={`${link.icon} text-base`}></i>
                  <span>{link.label}</span>
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#trending"
                onClick={() => setMenuOpen(false)}
                className="block text-center whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-3 text-sm font-bold"
              >
                开始看番
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}